<template>
  <select id="cars" name="carlist" v-model="value">
    <option v-for="item in items" :key="item.id" :value="item.name">
      {{ item.name }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    items: {
      type: Object,
      required: true,
    },
    initialValue: {
      required: false,
      default: "",
    },
    initialErrors: {
      type: Array,
      required: false,
      default: () => [],
    },
    handleChange: {
      type: Function,
    },
  },
  data() {
    return {
      value: this.initialValue,
      errors: this.initialErrors,
    };
  },
  watch: {
    value: function (value) {
      this.$emit("handle-change", value);
    },
  },
};
</script>

<style>
</style>